import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

export default function AILoader() {
  return (
    <div style={styles.loader}>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1 }}
      >
        <Loader2 size={50} />
      </motion.div>

      <h2>AI is analyzing your business...</h2>
      <p>This may take a few seconds</p>
    </div>
  );
}

const styles = {
  loader: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }
};